import { CalendarDate, getLocalTimeZone, parseDate, today } from '@frontends/ds';

export const BIRTHDAY_MIN = new CalendarDate(1900, 1, 1);

export function getBirthdayMax(): CalendarDate {
  return today(getLocalTimeZone()).subtract({ years: 18 });
}

export function toLocalCalendarDate(date: Date): CalendarDate {
  return new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export function parseBirthday(value: string | null | undefined): Date | undefined {
  if (!value) {
    return undefined;
  }

  try {
    return parseDate(value.slice(0, 10)).toDate(getLocalTimeZone());
  } catch {
    return undefined;
  }
}
